// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zibi[data-v-5819569f]{font-family:Roboto-Black;font-size:19px;margin-top:10px;margin-bottom:10px;color:#fff}", ""]);
// Exports
module.exports = exports;
